import { createMemoryHistory, createBrowserHistory } from 'history'

const isDev = process.env.NODE_ENV === 'development'

export default isDev ? createBrowserHistory() : createMemoryHistory()
